const firebaseConfig = {
  apiKey: "AIzaSyCOku_EYXJCM4vPRMzuox5y989cDmGuM80",
  authDomain: "assignment-10-8dff4.firebaseapp.com",
  projectId: "assignment-10-8dff4",
  storageBucket: "assignment-10-8dff4.appspot.com",
  messagingSenderId: "669153175240",
  appId: "1:669153175240:web:70456b4e8a64bde284e7fd"
};

export default firebaseConfig;